<template>
  <div class="page_tePayment">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" v-loading="loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>暂支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/tePaymentList' }">待打款</el-breadcrumb-item>
          <el-breadcrumb-item>合作账户批量打款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="appTitle flex"> <span class="ss">|</span> 申请信息
          <div style="margin-left:50px;font-size:16px">合计金额： <span class="amount">￥{{Number(payForm.TotalFees).toFixed(2)}}</span></div>
        </div>

        <div v-for="(item,index) in baseInfo" :key="index" class="coopItem">
          <div class="appTitle2">暂支申请 {{index + 1}}</div>
          <div class="descriptions_box">
            <div class="descriptionsTitle" style="width:798px">{{item.applyCompany}}</div>
            <div class="descriptionsTitle" style="color: #666;width:798px">{{OAdata[index].type}}</div>
            <el-descriptions :column="4" border :contentStyle="CS" :label-style="LS " style="width:800px;">

              <el-descriptions-item label="暂支编号" :span="2" :contentStyle="{'max-width': '200px','min-width': '200px','text-align': 'center'}">{{item.advanceNum}}</el-descriptions-item>
              <el-descriptions-item label="OA编号" :span="2">{{item.oanum}}</el-descriptions-item>

              <el-descriptions-item label="签单部门" :span="2" :contentStyle="{'max-width': '200px','min-width': '200px','text-align': 'center'}">{{item.applyDep}}</el-descriptions-item>
              <el-descriptions-item label="业务员" :span="2"></el-descriptions-item>

              <el-descriptions-item label="服务部门" :span="2">{{item.sevrvceDeptName}}</el-descriptions-item>
              <el-descriptions-item label="客服" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}"></el-descriptions-item>
              <el-descriptions-item label="申请日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{item.applyTime ? item.applyTime.split('T')[0] : ''}}</el-descriptions-item>

              <el-descriptions-item label="所属项目" :span="2">{{item.projectName}}</el-descriptions-item>
              <el-descriptions-item label="客户名称" :span="2">{{item.CustomerName }}</el-descriptions-item>

              <el-descriptions-item label="内容" :span="2">{{ item.costName }}</el-descriptions-item>
              <el-descriptions-item label="业务属性" :span="2"></el-descriptions-item>

              <el-descriptions-item label="金额 大写(RMB)" :span="2">{{ numberToChinese(item.totalFees) }}</el-descriptions-item>
              <el-descriptions-item label="￥：" :span="2">{{item.totalFees}}</el-descriptions-item>

              <el-descriptions-item label="备注" :span="4">{{item.descFees}}</el-descriptions-item>

              <el-descriptions-item label="申请人" :span="2">{{item.applyUserName}}</el-descriptions-item>
              <el-descriptions-item label="业务审核" :span="2"></el-descriptions-item>

              <el-descriptions-item label="出纳确认" :span="2"></el-descriptions-item>
              <el-descriptions-item label="出纳" :span="2"></el-descriptions-item>

            </el-descriptions>
          </div>

          <div>
            <el-form :model="peyData[index]" :rules="rules" ref="payForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="打款金额" prop="TotalFees">
                <div class="payInput">
                  <el-input v-model="peyData[index].TotalFees" size="small" style="width:300px" @input="payInput" type="number">
                    <i slot="prepend">￥</i>
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="打款公司" prop="name">
                <el-input v-model="item.remitAgency" size="small" style="width:300px" disabled readonly></el-input>
              </el-form-item>
              <el-form-item label="收款账号名称" prop="name">
                <el-input v-model="item.receiptAccountName" size="small" style="width:300px" readonly disabled></el-input>
              </el-form-item>
              <el-form-item label="银行开户行" prop="name">
                <el-input v-model="item.depositBank" size="small" style="width:300px"></el-input>
              </el-form-item>
              <el-form-item label="银行卡号" prop="name">
                <el-input v-model="item.receiptAccount" size="small" style="width:300px" readonly disabled></el-input>
              </el-form-item>
              <el-form-item label="款项用途" prop="UseFunds">
                <el-input v-model="peyData[index].UseFunds" size="small" style="width:300px"></el-input>
              </el-form-item>
              <el-form-item label="是否需要核销" prop="ProcessState">
                <el-radio-group v-model="peyData[index].ProcessState">
                  <el-radio label="1">需要</el-radio>
                  <el-radio label="0">不需要</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>

          <div class="infoTitle incInfo">OA流程信息
            <el-button type="text" size="small" @click="getMore">
              <i :class="!showMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore ? '展开' : '收起' }}</el-button>
          </div>


          <div v-if="showMore" class="showPaymentInfo">

            <table width="1000px" border="0" cellspacing="1" cellpadding="4" class="tabtop15" align="center">
              <tr>
                <td colspan="4" class="bttit font-center titfont">{{OAdata[index].type}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">暂支编号</td>
                <td width="35%">{{OAdata[index].oaNumber}}</td>
                <td width="15%" class="bttit font-center">申请时间</td>
                <td width="35%">{{OAdata[index].applyTime.replace('0:00:00','')}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">申请公司</td>
                <td width="35%">{{OAdata[index].applyCompanyName}}</td>
                <td width="15%" class="bttit font-center">申请部门</td>
                <td width="35%">{{OAdata[index].applyDeptName}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">申请人</td>
                <td width="35%">{{OAdata[index].applyUserName}}</td>
                <td width="15%" class="bttit font-center"></td>
                <td width="35%"></td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">服务公司</td>
                <td width="35%">{{OAdata[index].serviceCompanyName}}</td>
                <td width="15%" class="bttit font-center">服务部门</td>
                <td width="35%">{{OAdata[index].serviceDeptName}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">服务客户</td>
                <td width="35%">{{OAdata[index].serviceCustomerName}}</td>
                <td width="15%" class="bttit font-center">服务中心/分子公司</td>
                <td width="35%">{{OAdata[index].serviceCenterOrCompany}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">费用明细</td>
                <td width="35%">{{OAdata[index].costName}}</td>
                <td width="15%" class="bttit font-center">费用金额</td>
                <td width="35%">{{OAdata[index].costAmount}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">打款时间</td>
                <td width="35%">{{OAdata[index].paymentTime}}</td>
                <td width="15%" class="bttit font-center">打款公司</td>
                <td width="35%">{{OAdata[index].remitCompany}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">费用说明</td>
                <td colspan="3">{{OAdata[index].costDesc }}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">开户银行</td>
                <td colspan="3">{{OAdata[index].bankName}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">收款人账户名</td>
                <td colspan="3">{{OAdata[index].paymentAccountName}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">银行账号</td>
                <td colspan="3">{{OAdata[index].paymentAccount}}</td>
              </tr>
              <!-- <tr v-for="(item,index) in advOaFileList" :key="index">
                <td width="15%" class="bttit font-center">{{ index == -1 ?'相关附件' : '相关附件' + (index+1)}}</td>
                <td colspan="3">
                  <span @click="toDownFile(item.oaDownloadurl)" class="blueName cp">{{item.fileName}}</span>
                </td>
              </tr> -->
              <tr v-if="advOaFileList.length==0">
                <td width="15%" class="bttit font-center">相关附件</td>
                <td colspan="3">
                  <span @click="toDownFile(OAdata[index].fileUrl)" class="blueName cp">{{OAdata[index].fileName && OAdata[index].fileUrl ? OAdata[index].fileName : ''}}</span>
                </td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">核销情况</td>
                <td width="35%">{{OAdata[index].name}}</td>
                <td width="15%" class="bttit font-center">核销金额</td>
                <td width="35%">{{OAdata[index].name}}</td>
              </tr>
              <tr>
                <td width="15%" class="bttit font-center">核销说明</td>
                <td colspan="3">{{OAdata[index].remark}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div>
          <div class="appTitle flex"> <span class="ss">|</span> 服务公司向合作账户转款
          </div>
          <div class="salaryPayingCompanyBox" style="margin-top:15px">
            <div class="salaryPayingCompany">选择真实账户：
              <el-select v-model="coop" placeholder="" size="small" style="width: 500px;" clearable filterable @change="changeCoop" value-key="acount">
                <el-option v-for="(item, index) in trueAccountData" :key="index" :label="item.acountName + '/' + item.acount + '/' + item.openingBank" :value="item"></el-option>
              </el-select>
            </div>

            <div class="salaryPayingCompany">选择服务公司：
              <el-select v-model="severCompany" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeSC">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
            <div class="salaryPayingCompany" v-if="severCompany">付款方：{{ baseInfo.remitAgency }}</div>
            <div class="salaryPayingCompany_radio" v-if="scBankAccount.length>0">
              <el-radio :label="bank" v-for="bank in scBankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="severItem" @input="val => { changeRadio(val) } ">开户行：{{ bank.OpeningBank }} 帐号：{{bank.Account}}</el-radio>
            </div>
            <div v-if="scBankAccount.length == 0 && severCompany" class="noAccountTips">暂未配置{{severCompany}}CBS银行账户</div>
            <div v-if="!severCompany" class="noAccountTips">请选择服务公司</div>
          </div>
          <div style="font-size:16px">合计金额： <span class="amount">￥{{Number(payForm.TotalFees).toFixed(2)}}</span></div>
          <div class="appTitle flex" style="margin:20px 0 10px 0"> <span class="ss">|</span> 内部转款
          </div>
          <div class="salaryPayingCompanyBox">
            <div class="salaryPayingCompany">
              <el-checkbox v-model="needInternal">（可选）向服务公司账户内部转款：</el-checkbox>
              <el-select v-model="internalCompany" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeIC">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
            <div class="salaryPayingCompany_radio" v-if="icBankAccount.length > 0">
              <el-radio :label="bank.Account" v-for="bank in icBankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.InternalAccount">开户行：{{ bank.OpeningBank }} 帐号：{{ bank.Account}}</el-radio>
            </div>
          </div>
          <div v-if="icBankAccount.length == 0" class="noAccountTips">暂未配置{{internalCompany}}CBS银行账户</div>

          <div class="salaryPayingCompany flex sb">
            <div>收款方：{{ severCompany}}</div>
          </div>
          <div>
            账户：{{ payForm.payAccount }}
          </div>
          <div style="margin-top:20px">
            <div class="salaryPayingCompany flex aic">打款金额：
              <div class="payInput">
                <el-input v-model="payForm.TotalFees" size="small" style="width:300px" type="number">
                  <i slot="prepend">￥</i>
                </el-input>
              </div>
            </div>
          </div>
        </div>

        <div class="botbox">
          <el-button type="primary" size="small" v-preventReClick :disabled="isPaySuccess" @click="confirmPay" :loading="isBtnLoading">打款</el-button>

          <el-button size="small" @click="cancel">返 回</el-button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          busiId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        ids: '',
        rules: {},
        baseInfo: [],
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        loading: false,
        BankAccount: [], //银行列表
        isBtnLoading: false,
        innerVisibleCA: false,
        peyData: [],
        coop: '',
        payForm: {
          TotalFees: 0,
          payAccount: "",
          payAccountName: "",
          payAccountDepositBank: '',
          InternalAccount: "",
          InternalAccountName: "",
          CooperatAccount: "",
          CooperatAccountName: "",
          CooperatAccountDepositBank: "",
          CnapsCode: "",
          BankCode: "",
          List: []
        },
        severItem: '', //服务公司账户
        legList: [],
        advOaFileList: [], //附件列表
        isPaySuccess: false,
        showMore: false, //展开OA信息
        OAinfo: {},
        trueAccountData: [], //真实账户列表
        showBindTrueAccount: false,
        payType: '', //0 正常模式 /3真实账户 /4虚拟账户
        coopList: [], //合作账户列表
        needInternal: false, //向打款账户内部转款
        internalCompany: '宁波英普瑞特供应链管理有限公司', //内部转账公司
        icBankAccount: [],
        OAdata: [],
        innerVisibleIC: false,
        VisibleCoop: false, //合作账户打款
        VisibleCoopSC: false, //选择服务公司
        severCompany: '', //服务公司
        scBankAccount: [],
        CS: {
          'text-align': 'center', //文本居中
          'min-width': '200px', //最小宽度
          'max-width': '200px',
          'word-break': 'break-all'
        },
        LS: {
          'background-color': 'fff',
          'text-align': 'center', //文本居中
          'min-width': '100px', //最小宽度
          'max-width': '100px',
        },
      }
    },
    created() {
      if (this.$route.query.ids != undefined && this.$route.query.ids) {
        this.ids = this.$route.query.ids;
        // this.GetAdvancesDetail()
        this.getAll();
      }
      this.getlegalsubjectlist();
      this.GetAdvCooperationaAcountList();
      this.changeIC('宁波英普瑞特供应链管理有限公司')
    },
    methods: {
      checkPermission,
      getAll() {
        let arr = this.ids.split(',');
        arr.forEach((element, index) => {
          this.GetAdvancesDetail(element, index)
        });
      },
      GetAdvancesDetail(id, index) {
        this.loading = true;
        let d = {
          busiId: id,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        xz.GetAdvancesDetail(d).then(res => {
          try {
            if (res.status == 'ok') {
              this.baseInfo.push(res.data.adVerifs);
              this.advOaFileList.push(res.data.advOaFileList);
              this.OAdata.push(res.data.list[0]);
              let data = {
                Id: id,
                TotalFees: res.data.adVerifs.totalFees,
                UseFunds: res.data.adVerifs.projectName + res.data.adVerifs.costName,
                ProcessState: '1'
              }
              data.UseFunds = data.UseFunds.replace('返费', '');
              data.UseFunds = data.UseFunds.replace('过账', '');
              this.peyData.push(data)
              this.payForm.TotalFees = this.payForm.TotalFees + Number(res.data.adVerifs.totalFees)
              // if (this.OAdata.length > 0 && this.OAdata[0].type != '工作日志') {
              //   this.OAinfo = this.OAdata[0]
              // }
              this.loading = false;
            } else {
              this.$message.error(res.msg);
              this.loading = false;
            }
          } catch {
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      getMore() {
        this.showMore = !this.showMore
      },
      //数字转中文大写
      numberToChinese(money) {
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      cancel() {
        this.$router.go(-1);
        // window.close();
      },
      //附件
      toDownFile(row) {
        const newWindow = window.open(url, "_blank");
      },
      payInput(val) {
        // this.payForm.TotalFees = Number(val).toFixed(2)
        this.payForm.TotalFees = 0
        this.peyData.forEach(element => {
          this.payForm.TotalFees = Number(this.payForm.TotalFees) + Number(element.TotalFees)
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //获取合作账户
      GetCompanyNameAccount() {
        xz.GetCompanyNameAccount(this.baseInfo.remitAgency).then(res => {
          if (res.status == 'ok') {
            this.payType = res.data.type;
            if (res.data.data != undefined && res.data.data.length > 0) {
              this.coopList = res.data.data;
              this.severCompany = res.data.data[0].compName;
              this.changeSC(this.severCompany)
            }
          } else {
            this.coopList = [];
          }
        })
      },
      changeSC(val) {
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.scBankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.payForm.payAccount = element.Account
                  }
                });
                this.scBankAccount = res.data.BankAccountJ;
              }
            } else {
              this.scBankAccount = [];
            }
          })
        }
      },
      //获取所有真实账户
      GetAdvCooperationaAcountList() {
        let data = {
          pageModel: {
            rows: 100,
            page: 1,
            orderInput: [{
              property: "updataTime",
              order: 0
            }]
          },
          id: "",
          compName: "",
          acountName: "",
          acount: "",
          openingBank: "",
          isCbsAcount: "",
          compType: 3,
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        }
        xz.AdvanceFun(data, 'GetAdvCooperationaAcountList').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.trueAccountData = res.data.data;
          } else {
            this.loading = false;
            this.trueAccountData = [];
          }
        })
      },
      changeIC(val) {
        console.log(val)
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.icBankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.InternalAccount = element.Account
                  }
                });
                this.icBankAccount = res.data.BankAccountJ;
              }
            } else {
              this.icBankAccount = [];
            }
          })
        }
      },
      changeCoop(val) {
        console.log(val)
        this.payForm.CooperatAccount = val.acount;
        this.payForm.CooperatAccountName = val.acountName;
        this.payForm.CooperatAccountDepositBank = val.openingBank;
        this.severCompany = val.compName;
        this.changeSC(val.compName)
      },
      confirmPay() {
        console.log(this.payForm)
        if (this.needInternal) {
          this.payForm.InternalAccount = this.InternalAccount;
          this.payForm.InternalAccountName = this.internalCompany
        }
        this.payForm.List = this.peyData
        this.isBtnLoading = true;
        // this.payForm.List.forEach(element => {
        //   element.TotalFees = 0.01;
        // });
        // this.payForm.TotalFees = 0.02;
        this.payForm.payAccountName = this.severCompany;
        xz.remitAdvance3(this.payForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('打款成功！');
            this.isBtnLoading = false;
            this.isPaySuccess = true;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      changeRadio(val) {
        this.payForm.payAccount = val.Account;
        this.payForm.payAccountDepositBank = val.OpeningBank;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .showPaymentInfo {
    // width: 1161px;
  }

  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .showMore {
    width: 1088px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    border: 1px solid #ebebeb;
    border-top: 1px solid #eaeefb;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .descriptions_box {
    margin-bottom: 20px;
  }

  .descriptionsTitle {
    border: 1px solid #B7BABD;
    border-bottom: none;
    // margin: 0 auto;
    padding: 8px 0;
    font-size: 13px;
    font-weight: 600;
    color: #000;
    text-align: center;
  }

  .botbox {
    padding-left: 60px;
    margin-top: 30px;
    padding-bottom: 20px;
  }

  .salaryPayingCompanyItem {
    margin-bottom: 30px;
  }

  .salaryPayingCompany {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .salaryPayingCompany_radio {
    padding-left: 30px;
    max-width: 800px;
  }

  .tabtop13 {
    margin-top: 5px;
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .tabtop15 td {
    padding: 8px;
    word-break: break-word;
    font-size: 14px;
  }

  .font-center {
    text-align: center
  }

  .biaoti {
    font-family: 微软雅黑;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px dashed #CCCCCC;
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
    // background: url(../images/ico3.gif) no-repeat 15px center;
  }

  .bttit {
    background: #F6F6F6 !important;
  }

  .tabtxt2 {
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
  }

  .tabtxt3 {
    font-family: 微软雅黑;
    font-size: 14px;
    padding-left: 15px;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
  }

  .showPaymentInfo table td,
  .showPaymentInfo table th {
    border: 1px #d2d2d2 solid;
  }

  .addressSelect {
    width: 500px;
    position: absolute;
    top: 40px;
    background: #fff;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 200px;
    width: 300px;
    overflow: auto;
    padding: 10px 0;
    z-index: 2000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  .addressSelectItem {
    padding: 0 0 0 10px;
  }

  .remake {
    color: #AAAAAA;
    margin-left: 10px;
    font-size: 12px;
  }

  .noAccountTips {
    font-size: 14px;
    margin-bottom: 15px;
  }

  .coopItem {
    border-bottom: 1px solid #CECECE;
    padding: 20px;
  }

  .appTitle {
    font-size: 14px;
    font-weight: bold;
    padding-top: 10px;
  }

  .ss {
    color: #F59A5C;
    font-size: 16px;
  }

  .amount {
    color: #CC0000;
  }

  .appTitle2 {
    font-size: 14px;
    margin-bottom: 10px;
  }
</style>
<style>
  .page_tePayment .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePayment .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tePayment .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePayment .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePayment .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 1px solid #B7BABD;
  }

  .payInput .el-input-group__append,
  .payInput .el-input-group__prepend {
    padding: 0 0 0 5px;
    background: #fff;
    border-right: none !important;
  }

  .payInput .el-input__inner {
    border-left-color: #fff;
    padding-left: 3px;
  }

  .page_tePayment .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>